import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  ArcElement,
  DoughnutController,
  Tooltip,
  Legend,
} from "chart.js";

/** Light “Figma card” tooltips for all POS dashboard Chart.js instances (canvas-drawn). */
const DASHBOARD_TOOLTIP_THEME = {
  enabled: true,
  displayColors: true,
  usePointStyle: true,
  boxPadding: 4,
  boxWidth: 8,
  boxHeight: 8,
  padding: 12,
  cornerRadius: 8,
  caretSize: 0,
  caretPadding: 10,
  backgroundColor: "#ffffff",
  titleColor: "#2a2a2a",
  bodyColor: "#2a2a2a",
  footerColor: "#2a2a2a",
  borderColor: "#e3e3e3",
  borderWidth: 1,
  titleFont: {
    family: "'Segoe UI', 'Inter', Roboto, sans-serif",
    size: 12,
    weight: "400",
  },
  bodyFont: {
    family: "'Segoe UI', 'Inter', Roboto, sans-serif",
    size: 12,
    weight: "600",
  },
  titleMarginBottom: 6,
};

/** One-time registration for inline dashboard charts */
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  ArcElement,
  DoughnutController,
  Tooltip,
  Legend,
);

ChartJS.defaults.plugins.tooltip = {
  ...ChartJS.defaults.plugins.tooltip,
  ...DASHBOARD_TOOLTIP_THEME,
};

export { ChartJS, DASHBOARD_TOOLTIP_THEME };
